export const formatIdleDateTimeLine = (date: Date = new Date()): string => {
  const weekday = date
    .toLocaleDateString("en-US", { weekday: "short" })
    .toUpperCase();
  const dayMonth = date
    .toLocaleDateString("en-US", { day: "2-digit", month: "short" })
    .toUpperCase()
    .replace(",", "");
  const time = date
    .toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .replace(/\s/g, " ")
    .toUpperCase();
  return `${weekday} · ${dayMonth} · ${time}`;
};

export const formatTimeAgoShort = (isoTime?: string): string => {
  if (!isoTime) return "—";
  const then = new Date(isoTime);
  if (Number.isNaN(then.getTime())) return "—";
  const diffMs = Date.now() - then.getTime();
  if (diffMs < 0) return "Just now";
  const hours = Math.floor(diffMs / 3_600_000);
  const mins = Math.floor((diffMs % 3_600_000) / 60_000);
  if (hours > 0) return `${hours}H ${mins}M AGO`;
  if (mins > 0) return `${mins}M AGO`;
  return "Just now";
};

export const getTimeOfDayGreeting = (date: Date = new Date()): string => {
  const hour = date.getHours();
  if (hour < 12) return "Good Morning";
  if (hour < 17) return "Good Afternoon";
  return "Good Evening";
};

export const formatTitleCaseGreeting = (raw?: string): string => {
  const base = raw?.trim() || getTimeOfDayGreeting();
  return base
    .replace(/,?\s*$/i, "")
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const capitalizeActivityLabel = (label: string): string =>
  label
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");

export const getNextMealContext = () => {
  const hour = new Date().getHours();
  if (hour < 11) {
    return {
      label: "LUNCH",
      meal: "lunch",
      title: "Plan ahead for lunch",
      tip: "Your lunch rice spikes are often highest. Log before eating to see your curve.",
    };
  }
  if (hour < 15) {
    return {
      label: "SNACK",
      meal: "snack",
      title: "Plan ahead for your snack",
      tip: "Afternoon snacks add up — a quick photo helps predict the next 2 hours.",
    };
  }
  return {
    label: "DINNER",
    meal: "dinner",
    title: "Plan ahead for dinner",
    tip: "Dinner rice spikes are often your highest. Log before eating to bend the peak.",
  };
};

export const formatMinutesShort = (mins: number): string => {
  const hours = Math.floor(mins / 60);
  const minutes = mins % 60;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes} min`;
};

export const formatMealElapsedShort = (isoTime?: string): string => {
  if (!isoTime) return "recently";
  const then = new Date(isoTime);
  if (Number.isNaN(then.getTime())) return "recently";
  const diffMs = Date.now() - then.getTime();
  if (diffMs < 0) return "just now";
  const hours = Math.floor(diffMs / 3_600_000);
  const mins = Math.floor((diffMs % 3_600_000) / 60_000);
  if (hours > 0) return `${hours}h ago`;
  if (mins > 0) return `${mins}m ago`;
  return "just now";
};

/** Returns "1H 47M AGO" format for last meal card header */
export const formatMealElapsedLong = (isoTime?: string): string => {
  if (!isoTime) return "";
  const then = new Date(isoTime);
  if (Number.isNaN(then.getTime())) return "";
  const diffMs = Date.now() - then.getTime();
  if (diffMs < 0) return "JUST NOW";
  const hours = Math.floor(diffMs / 3_600_000);
  const mins = Math.floor((diffMs % 3_600_000) / 60_000);
  if (hours > 0) return `${hours}H ${mins}M AGO`;
  if (mins > 0) return `${mins}M AGO`;
  return "JUST NOW";
};

export const formatEatingWindowBadge = (
  timeRemainingUi?: string | null,
  timeRemaining?: string | null
): string => {
  const raw = (timeRemainingUi || timeRemaining || "").trim();
  if (!raw) return "EATING WINDOW";
  const normalized = raw.replace(/\s*left\s*/i, "").trim();
  return `EATING WINDOW · ${normalized.toUpperCase()} LEFT`;
};
